import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
// import GetAppIcon from '@material-ui/icons/GetApp'
// import AddIcon from '@material-ui/icons/Add'
import { Grid } from '@material-ui/core'
import { getMasterDetailSubProyect } from '../../../../../services/Elegibilidad/get'
import { Modal54Edit } from '../../Modals/ModalSec5Edit/Modal54Edit'
import { deleteSubprojectBudget } from '../../../../../services/Elegibilidad/delete'
import swal from 'sweetalert'
import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import NumberFormat from 'react-number-format'

const Table541 = ({ rowData, getDataTableMaster }) => {
  const { idElegibilityForm } = useFormElegibilidad()
  const { IdDataField } = rowData
  const [tableData, setTableData] = useState([])
  const [openEdit, setOpenEdit] = useState(false)
  const [body, setBody] = useState({})

  const getDataTable = async () => {
    const body = {
      IdElegibilityAnswer: idElegibilityForm,
      IdCategory: IdDataField,
    }
    try {
      const response = await getMasterDetailSubProyect(body)
      if (response.Success) {
        setTableData(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getDataTable()
  }, [])

  const handleDelete = async (id) => {
    try {
      const response = await deleteSubprojectBudget(id)
      if (response.Success) {
        swal({
          title: '¡Datos eliminados exitosamente!',
          icon: 'success',
        })

        getDataTableMaster()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const columns = [
    {
      title: 'Descripción',
      field: 'Description',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Unidad',
      field: 'Unit',
      align: 'right',
    },
    {
      title: 'Cantidad',
      field: 'Quantity',

      align: 'right',
      render: (expense) => (
        <NumberFormat
          value={expense.Quantity}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
    {
      title: 'Costo Unitario',
      field: 'UnitCost',
      align: 'right',
      type: 'string',
      render: (expense) => (
        <NumberFormat
          value={expense.UnitCost}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
    {
      title: 'Costo Total',
      field: 'TotalCost',
      align: 'right',
      type: 'string',
      render: (expense) => (
        <NumberFormat
          value={expense.TotalCost}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
    {
      title: 'Préstamos',
      field: 'LoanContribution',
      align: 'right',
      type: 'string',
      render: (expense) => (
        <NumberFormat
          value={expense.LoanContribution}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
    {
      title: 'MIPYME',
      field: 'MIPYMEContribution',
      align: 'right',
      type: 'string',
      render: (expense) => (
        <NumberFormat
          value={expense.MIPYMEContribution}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
    {
      title: 'Otros Aportes',
      field: 'OtherContributions',
      align: 'right',
      type: 'string',
      render: (expense) => (
        <NumberFormat
          value={expense.OtherContributions}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
  ]
  return (
    <div className="App2">
      <Grid item xs={12} sm={12} md={12}>
        <MaterialTable
          columns={columns}
          data={tableData}
          actions={[
            {
              icon: () => <EditIcon style={{ color: '#0d53ad' }} />,
              tooltip: 'Editar',
              onClick: (event, rowData) => {
                setOpenEdit(true)
                setBody(rowData)
              },
            },
            {
              icon: () => <DeleteIcon style={{ color: 'red' }} />,
              tooltip: 'Eliminar registro',
              onClick: (event, rowData) => {
                swal({
                  title: '¿Está seguro de eliminar el registro?',
                  icon: 'warning',
                  buttons: ['No', 'Si'],
                  dangerMode: true,
                }).then(function (isConfirm) {
                  if (isConfirm) {
                    handleDelete(rowData.IdSubprojectBudget)
                  }
                })
              },
            },
          ]}
          onSelectionChange={(selectedRows) => console.log(selectedRows)}
          options={{
            sorting: false,
            search: false,
            searchFieldAlignment: 'right',
            searchAutoFocus: true,
            searchFieldVariant: 'standard',
            filtering: false,
            paging: false,
            pageSizeOptions: [2, 5, 10],
            pageSize: 5,
            paginationType: 'stepped',
            showFirstLastPageButtons: false,
            paginationPosition: 'bottom',
            exportButton: false,
            exportAllData: false,
            exportFileName: 'TableData',
            addRowPosition: 'first',
            actionsColumnIndex: -1,
            showSelectAllCheckbox: false,
            showTextRowsSelected: false,
            grouping: false,
            columnsButton: false,
            toolbar: false,
            rowStyle: (data, index) =>
              index % 2 === 0 ? { background: '#f5f5f5' } : null,
            headerStyle: { background: '#0f79af', color: '#fff' },
          }}
          localization={{
            body: {
              editRow: {
                deleteText: '¿Está seguro de eliminar el registro?',
              },
              emptyDataSourceMessage: 'Sin registros',
            },
            header: {
              actions: 'Acciones',
            },
            toolbar: {
              searchPlaceholder: 'Buscar',
            },
          }}
          title=" "
        />
        <Modal54Edit
          open={openEdit}
          setOpen={setOpenEdit}
          body={body}
          setBody={setBody}
          getDataTable={getDataTable}
          getDataTableMaster={getDataTableMaster}
        />
      </Grid>
    </div>
  )
}

export default Table541
